import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { payToAdvisorAction } from "../../actions/advisor";

export default function PayAdvisorModal({
    isOpen,
    onClose,
    advisor,          // { id?: string|number, _id?: string, name?: string }
    payoutId,        // optional: pass if you already know the payout this pay belongs to
}) {
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
        setValue
    } = useForm({
        defaultValues: { amount: "", notes: "" },
        mode: "onTouched",
    });

    // reset when opening/closing or advisor changes
    React.useEffect(() => {
        if (isOpen) {
            reset({ amount: "", notes: "" });
            setValue('amount', advisor?.pending)
        }
    }, [isOpen, advisor, reset]);

    const submit = async (data) => {
        if (data) {

            const payload = {
                advisorId: advisor?.advisor?.id ?? advisor?.advisor?._id,           // support either shape
                payoutId: advisor?.id ?? advisor?._id,                  // send only if provided
                amount: Number(data.amount),
                notes: (data.notes || "").trim(),
            };
            await dispatch(payToAdvisorAction(payload));
            onClose?.();
        }
    };

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            centered
            backdrop={true}        // click outside closes (same as your previous UX)
            keyboard={true}        // ESC closes
            contentClassName="pay-modal-card"  // keep our styling
        >
            <div className="pay-modal-header">
                <h2 id="pay-title">
                    Pay Advisor{advisor?.name ? ` — ${advisor.name}` : ""}
                </h2>
                <button
                    type="button"
                    className="icon-btn"
                    aria-label="Close"
                    onClick={onClose}
                >
                    ×
                </button>
            </div>

            <div className="pay-modal-body">
                <form onSubmit={handleSubmit(submit)} noValidate>
                    <div className="form-field">
                        <label htmlFor="amount">Amount</label>
                        <input
                            id="amount"
                            type="number"
                            step="0.01"
                            inputMode="decimal"
                            placeholder="0.00"
                            {...register("amount", {
                                required: "Amount is required",
                                valueAsNumber: true,
                                validate: (v) =>
                                    (typeof v === "number" && !Number.isNaN(v) && v >= 0.01) ||
                                    "Enter a valid amount (≥ 0.01)",
                            })}
                        />
                        {errors.amount && <p className="error">{errors.amount.message}</p>}
                    </div>

                    <div className="form-field">
                        <label htmlFor="notes">Notes (optional)</label>
                        <textarea
                            id="notes"
                            rows={4}
                            placeholder="Add an internal note for this payment…"
                            {...register("notes", {
                                maxLength: {
                                    value: 1000,
                                    message: "Notes must be under 1000 characters",
                                },
                            })}
                        />
                        {errors.notes && <p className="error">{errors.notes.message}</p>}
                    </div>

                    <div className="pay-modal-footer">
                        <button type="button" className="btn ghost" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn primary" disabled={isSubmitting}>
                            {isSubmitting ? "Processing…" : "Pay Advisor"}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}